import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "gl-theme";

function readInitialMode() {
  if (typeof document === "undefined") return "dark";
  const attr = document.documentElement.getAttribute("data-theme");
  return attr === "light" ? "light" : "dark";
}

/**
 * Tema claro/escuro persistido em localStorage.
 * O valor inicial é aplicado no <html> por um script inline em public/index.html,
 * evitando flash de tema errado no primeiro paint.
 */
export function useThemeMode() {
  const [mode, setMode] = useState(readInitialMode);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* storage indisponível — o tema segue válido nesta sessão */
    }
  }, [mode]);

  const toggle = useCallback(() => {
    setMode((current) => (current === "dark" ? "light" : "dark"));
  }, []);

  return { mode, toggle };
}
